const quick = [
  { href: "#hot", label: "今日热搜" },
  { href: "#latest", label: "新瓜速递" },
  { href: "#category", label: "分类快报" },
  { href: "#debate", label: "网友热议" },
  { href: "#about", label: "关于本站" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-lg text-white">
                <i className="ri-fire-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-white">吃瓜最新</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-300/90">
              今日新瓜热榜门户，实时汇聚当天热点与最新爆料。理性吃瓜、文明围观，不错过任何一条刚发生的劲爆消息。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-secondary-400">
              <i className="ri-mail-line" aria-hidden="true" />
              <a href="mailto:editor@chigua-latest.example" className="hover:text-accent-300">
                editor@chigua-latest.example
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            <div>
              <p className="font-heading text-sm font-bold text-white">快捷导航</p>
              <ul className="mt-4 space-y-2.5">
                {quick.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      className="text-sm text-secondary-300/90 transition-colors hover:text-accent-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-heading text-sm font-bold text-white">围观指南</p>
              <ul className="mt-4 space-y-2.5 text-sm text-secondary-300/90">
                <li>如何判断瓜的真假</li>
                <li>热搜热度怎么来的</li>
                <li>理性围观小贴士</li>
              </ul>
            </div>
            <div>
              <p className="font-heading text-sm font-bold text-white">投稿建议</p>
              <ul className="mt-4 space-y-2.5 text-sm text-secondary-300/90">
                <li>投稿需提供可靠信源</li>
                <li>图文并茂更容易收录</li>
                <li>工作日实时审核更新</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-secondary-700/50 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-400">
            © {new Date().getFullYear()} 吃瓜最新 · 当天热点速递站，内容整理自公开信息，仅作讨论参考。
          </p>
          <p className="flex items-center gap-1.5 text-xs text-secondary-400">
            <i className="ri-leaf-line text-accent-400" aria-hidden="true" />
            理性吃瓜 · 文明围观
          </p>
        </div>
      </div>
    </footer>
  );
}